__turbopack_context__.v({
  "lowStock": "productStock-module-scss-module__8UH7gG__lowStock",
  "nearBy": "productStock-module-scss-module__8UH7gG__nearBy",
  "outOfStock": "productStock-module-scss-module__8UH7gG__outOfStock",
  "status": "productStock-module-scss-module__8UH7gG__status",
  "stock": "productStock-module-scss-module__8UH7gG__stock",
  "stockIndicator": "productStock-module-scss-module__8UH7gG__stockIndicator",
  "storeModal": "productStock-module-scss-module__8UH7gG__storeModal",
  "storeModalWrapper": "productStock-module-scss-module__8UH7gG__storeModalWrapper",
});
